import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Subject} from 'rxjs';

import {CanvasStoreComponent} from '../canvas-store/canvas-store.component';
import {isCanvasStoreAllowed, isViewMode, isViewModeByShareLink} from '@src/configs/view_only';
import {GlobalScreenshotComponent} from '@src/app/components_2.1/global-screenshot/global-screenshot.component';
import {SignUpModalComponent} from '@src/app/modules/user-guide/modals/sign-up-modal/sign-up-modal.component';
import {UserGuideService} from '@modules/user-guide/shared/user-guide.service';
import {ModalService} from '@src/app/core/services/modal.service';
import {LinkShareModalComponent} from '@src/app/components_2.1/link-share-modal/link-share-modal.component';
import {EventService} from '@src/app/core/services/event.service';

@Component({
  selector: 'app-last-header-btns',
  templateUrl: './last-header-btns.component.html',
  styleUrls: ['./last-header-btns.component.scss'],
})
export class LastHeaderBtnsComponent implements AfterViewInit, OnDestroy {
  @ViewChild(GlobalScreenshotComponent, {static: false})
  private globalScreenshotComponent: GlobalScreenshotComponent;

  @ViewChild(CanvasStoreComponent, {static: false})
  private canvasStoreComponent: CanvasStoreComponent;

  private destroyer$: Subject<void> = new Subject();

  isCanvasStoreAllowed = isCanvasStoreAllowed;
  isUserGuideEnabled: boolean;
  isEventAdmin: boolean;
  isViewModeOnly = isViewMode || isViewModeByShareLink;

  constructor(
    private matDialog: MatDialog,
    private userGuideService: UserGuideService,
    private modalService: ModalService,
    private eventService: EventService
  ) {}

  ngAfterViewInit(): void {
    // Keep the manipulation of buttons all within this component
    this.isUserGuideEnabled = this.userGuideService.isFastSignup;

    if (this.isUserGuideEnabled) {
      this.openModal = this.openSignUpModal;
      this.moveToShareUrl = this.openSignUpModal;
      this.globalScreenshotComponent.screenshotClipboard =
        this.openSignUpModal.bind(this);
    }
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.unsubscribe();
  }

  openModal(): void {
    if (this.isCanvasStoreAllowed) {
      this.canvasStoreComponent.show();
    }
  }

  moveToShareUrl(): void {
    // Just in case if users un-disable button through dev tools
    if (this.isViewModeOnly) { return; }

    let basePath = window.location.hostname;
    let resultPathName = window.location.pathname;
    resultPathName = resultPathName.substr(
      0,
      resultPathName.indexOf('/event/') + 7
    );
    resultPathName =
      basePath +
      resultPathName +
      'update/' +
      window['EVENT_ID'] +
      '#sharing-tab';
    location.href = location.protocol + '//' + resultPathName;
  }

  openSignUpModal(): void {
    this.matDialog.open(SignUpModalComponent);
  }

  openLinkShareModal(): void {
    if (!this.canOpenLinkShare) {
      return;
    }

    this.modalService.open(LinkShareModalComponent, {width: '600px'});
  }

  get canOpenLinkShare(): boolean {
    return !this.eventService.isLinkShare && this.eventService.isEventAdmin;
  }

  get linkShareTooltip(): string {
    let text = 'Create a view-only link';

    if (!this.canOpenLinkShare) {
      text = 'Only the event admins can create a shareable link';
    }

    return text;
  }
}
